import { Signal } from "@angular/core";

export function getById<T>(recordSignal: Signal<Record<string, T>>, id: string): T {
  const item = recordSignal()[id];
  if (item === undefined) {
    throw new Error(`Item with id ${id} not found`);
  }
  return item;
}

export function getByIds<T>(recordSignal: Signal<Record<string, T>>, Ids: string[]): T[] {
  const data = Ids.map((id) => {
    const item = getById(recordSignal, id);
    if (item === undefined || item === null) {
      throw new Error(`Item with id ${id} not found`);
    }
    return item;
  });
  return data;
}

export function recordFromMap<T>(map: Map<string, T>): Record<string, T> {
  const record: Record<string, T> = {};

  map.forEach((value, key) => {
    if (value === undefined) {
      throw new Error(
        `FromMap: Could not create Record from map, value is undefined. Key: ${key}, Value: ${JSON.stringify(map)}`
      );
    }
    record[key] = value;
  });

  return record;
}

export function recordfromRecord<T>(oldRecord: Record<string, T>): Record<string, T> {
  const newRecord: Record<string, T> = {};
  for (const key in oldRecord) {
    const value = oldRecord[key];
    if (value === undefined) {
      throw new Error(
        `FromRecord: Could not create Record from object, value is undefined. Key: ${key}, Value: ${JSON.stringify(
          oldRecord
        )}`
      );
    }
    newRecord[key] = value;
  }
  return newRecord;
}

export function recordFromArrays<T>(keys: string[], values: T[]): Record<string, T> {
  if (keys.length !== values.length) {
    throw new Error('FromArrays: Keys and values arrays must have the same length');
  }
  const record: Record<string, T> = {};
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = values[i];
    if (key === undefined || value === undefined) {
      throw new Error(
        `Could not create Record from array, key or value is undefined. Key: ${JSON.stringify(
          keys
        )}, Value: ${JSON.stringify(values)}`
      );
    }
    record[key] = value;
  }
  return record;
}

export function recordSet<T>(record: Record<string, T>, key: string, value: T): void {
  record[key] = value;
}

export function recordAttemptGet<T>(record: Record<string, T>, key: string): T | undefined {
  let value: T | undefined = undefined;
  try
  {
    value = record[key];
  }
  catch(e)
  {
    console.log('recordAttemptGet: Error getting value from record', e);
  }
  return value;
}

export function recordGet<T>(record: Record<string, T>, key: string): T {
  const value = record[key];
  if (value === undefined) {
    throw new Error(
      `Record Get: Could not get value from record, value is undefined. Key: ${key}, Value: ${JSON.stringify(record)}`
    );
  }
  return value;
}

export function recordAsArray<T>(record: Record<string, T>): Readonly<T[]> {
  return Object.values(record) as Readonly<T[]>;
}

export function recordForEach<T>(record: Record<string, T>, callback: (value: T, key: string) => void): void {
  for (const key in record) {
    const value = record[key];
    if (value !== undefined) {
      callback(value, key);
    }
  }
}
